import { addDays, isSameDay, startOfDay, subDays } from "date-fns";
import { prazoEfetivo } from "@bookdental/schemas";
import type { ClinicOutgoingOrder } from "@/lib/dashboard-lab";

export type GrupoDoResumo = "atrasado" | "hoje" | "proximos7" | "depois";

export const GRUPOS: { chave: GrupoDoResumo; rotulo: string; cor: string }[] = [
  { chave: "atrasado", rotulo: "Atrasado", cor: "#ef4444" },
  { chave: "hoje", rotulo: "Hoje", cor: "#2457ff" },
  { chave: "proximos7", rotulo: "Próximos 7 dias", cor: "#0ea5e9" },
  { chave: "depois", rotulo: "Mais adiante", cor: "#f59e0b" },
];

const FORA_DO_RESUMO = new Set(["CONCLUIDO", "CANCELADO", "RECUSADO"]);

/** Data de entrega: a pedida pelo dentista ou, sem ela, criação + prazo padrão do laboratório. */
export const entregaDe = (o: ClinicOutgoingOrder) => prazoEfetivo(o, o.prazo);

export function grupoDe(o: ClinicOutgoingOrder): GrupoDoResumo | null {
  if (FORA_DO_RESUMO.has(o.status)) return null;
  const hoje = startOfDay(new Date());
  const entrega = entregaDe(o);
  if (entrega < hoje) return "atrasado";
  if (isSameDay(entrega, hoje)) return "hoje";
  if (entrega <= addDays(hoje, 7)) return "proximos7";
  return "depois";
}

/** Recusa só interessa enquanto é novidade — passado um mês, o pedido já foi refeito ou esquecido. */
export const recusadoRecente = (o: ClinicOutgoingOrder) =>
  o.status === "RECUSADO" && new Date(o.createdAt) >= subDays(new Date(), 30);

/** Todos os serviços do pedido, com os dentes — no cartão largo do resumo cabe mais que o primeiro. */
export function servicosDe(o: ClinicOutgoingOrder): string {
  if (o.services.length === 0) return "Sem serviço";
  return o.services.map((s) => (s.teeth ? `${s.serviceCategory.label} (${s.teeth})` : s.serviceCategory.label)).join(", ");
}

export const ROTULO_DO_STATUS: Partial<Record<ClinicOutgoingOrder["status"], string>> = {
  AGUARDANDO_CONFIRMACAO: "Aguardando aceite",
};
